import EventsTable from '@/components/events/EventsTable';

export default function Events() {
	return (
		<div className="flex items-center h-full pt-10 flex-col">
			<EventsTable />
		</div>
	);
}
